// Records whether the persisted session is a guest session. Lives in
// localStorage (not sessionStorage) so it survives a reload, which is what lets
// AuthProvider's bootstrap know to refresh against /api/guest/* instead of
// /api/auth/*. It is NOT sensitive — the refresh token itself stays in an
// httpOnly cookie; this is only a routing hint.
const AUTH_MODE_KEY = 'sahib:auth-mode';

export type AuthMode = 'guest';

export function getAuthMode(): AuthMode | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(AUTH_MODE_KEY) === 'guest' ? 'guest' : null;
  } catch {
    return null;
  }
}

export function setAuthMode(mode: AuthMode): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(AUTH_MODE_KEY, mode);
  } catch {
    // localStorage unavailable — silently degrade (guest session just won't
    // survive a reload).
  }
}

export function clearAuthMode(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(AUTH_MODE_KEY);
  } catch {
    // ignore
  }
}
